export {default, initialState} from './reducer';
export * from './actions';

// active:
// Indicates that the user is "active" in the system for the given ttl or until another event is received.
export const PRESENCE_TYPE_ACTIVE = 'active';
// inactive:
// Indicates that the user should be considered "inactive" for the given ttl or until another event is received
export const PRESENCE_TYPE_INACTIVE = 'inactive';
// dnd:
// Indicates a desire by the user to not be disturbed for the given ttl.A TTL= 0 indicates canceling current dnd state
export const PRESENCE_TYPE_DND = 'dnd';
// ooo:
// Indicates that the user is "out of office" for the given ttl.A TTL= 0 indicates canceling current ooo state
export const PRESENCE_TYPE_OOO = 'ooo';
